import { coerceBooleanProperty } from '@angular/cdk/coercion';
import { Component, ContentChild, HostBinding, Input } from '@angular/core';
import { MuiComponent } from '../utility/mui-component-base/mui-component';
import { MuiCardHeader } from './mui-card-header.component';
import { MUI_CARD } from './mui-card.provider';


@Component({
  selector: 'mui-card',
  template: `
    <ng-content select="mui-card-header"></ng-content>
    <ng-content></ng-content>
    <ng-content select="mui-card-actions"></ng-content>
  `,
  providers: [{ provide: MUI_CARD, useExisting: MuiCard }],
  styleUrls: ['./mui-card.component.scss']
})
export class MuiCard extends MuiComponent {
  private static index = 0;

  readonly uid = 'mui-card-' + MuiCard.index++;

  @HostBinding('attr.aria-labelledby')
  get ariaLabelledBy(): string | null {
    return this._header?.id || null;
  }

  @Input()
  set sidebar(value: boolean | string) {
    this._sidebar = coerceBooleanProperty(value);
  }

  @ContentChild(MuiCardHeader)
  private _header?: MuiCardHeader;

  @HostBinding('attr.role')
  private readonly _role = 'region';

  @HostBinding('class')
  private readonly _class = 'mui-card';


  @HostBinding('class.mui-card--sidebar')
  private _sidebar = false;
}
